import { Icon } from '@iconify/react';

const TrustedBrands = () => {
  const brands = [
    { name: 'mandiri', icon: 'mdi:bank', color: '#1A73E8' },
    { name: 'BCA', icon: 'mdi:bank-outline', color: '#0066B3' },
    { name: 'BNI', icon: 'mdi:bank-circle', color: '#004C97' },
    { name: 'Tokopedia', icon: 'mdi:shopping', color: '#42B549' },
    { name: 'Gojek', icon: 'mdi:truck-delivery', color: '#00A9A6' },
    { name: 'Bukalapak', icon: 'mdi:cellphone', color: '#ED1C24' },
  ];

  return (
    <section className="py-12 border-b border-gray-100 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Title */}
        <p className="text-center text-xs font-medium text-gray-400 uppercase tracking-widest mb-8">
          Dipercayai oleh perusahaan terkemuka
        </p>

        {/* Brands Grid */}
        <div className="flex flex-wrap items-center justify-center gap-10 md:gap-16 opacity-60 hover:opacity-100 transition-opacity duration-500">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-xl font-bold text-gray-700 hover:text-zentra-600 transition-colors duration-300 group cursor-default"
            >
              <Icon
                icon={brand.icon}
                className="text-2xl transition-transform duration-300 group-hover:scale-110"
                style={{ color: brand.color }}
              />
              <span className="group-hover:text-zentra-600 transition-colors duration-300">
                {brand.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBrands;
